import { render } from "./newSidebar.vue?vue&type=template&id=38a987f5&scoped=true"
import script from "./newSidebar.vue?vue&type=script&lang=js"
export * from "./newSidebar.vue?vue&type=script&lang=js"

import "./newSidebar.vue?vue&type=style&index=0&id=38a987f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a987f5"]])

export default __exports__